import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // web: localStorage
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/REGISTER"],
        ignoredActionPaths: ["register"],
        ignoredPaths: ["register"],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

export { store, persistor };
